import Phaser from 'phaser'
import gameData from '../gameData';
import Key from './Key';
import ABCyaLib from '@abcya/abcya_lib';

export default class Keyboard extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene)
    {
        super(scene);

        let keyboardHeight = (gameData.isMobile) ? 400 : 0;
        this.setSize(this.scene.scale.width, keyboardHeight);

        let bgShape = this.scene.add.rectangle(-this.scene.scale.width / 2, 0, this.scene.scale.width, 400, 0x3258a7).setOrigin(0);
        this.add(bgShape);

        this.isActive = false;
        this.keySizeHeight = ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS ? 50 : 60;
        this.keySizeWidth = 50;
        this.keySpacing = 8;

        this.codes = [
            { code: 32, key: "space" },
            { code: 65, key: "a" },
            { code: 66, key: "b" },
            { code: 67, key: "c" },
            { code: 68, key: "d" },
            { code: 69, key: "e" },
            { code: 70, key: "f" },
            { code: 71, key: "g" },
            { code: 72, key: "h" },
            { code: 73, key: "i" },
            { code: 74, key: "j" },
            { code: 75, key: "k" },
            { code: 76, key: "l" },
            { code: 77, key: "m" },
            { code: 78, key: "n" },
            { code: 79, key: "o" },
            { code: 80, key: "p" },
            { code: 81, key: "q" },
            { code: 82, key: "r" },
            { code: 83, key: "s" },
            { code: 84, key: "t" },
            { code: 85, key: "u" },
            { code: 86, key: "v" },
            { code: 87, key: "w" },
            { code: 88, key: "x" },
            { code: 89, key: "y" },
            { code: 90, key: "z" },
            { code: 48, key: "0", shiftValue: ")" },
            { code: 49, key: "1", shiftValue: "!" },
            { code: 50, key: "2", shiftValue: "@" },
            { code: 51, key: "3", shiftValue: "#" },
            { code: 52, key: "4", shiftValue: "$" },
            { code: 53, key: "5", shiftValue: "%" },
            { code: 54, key: "6", shiftValue: "^" },
            { code: 55, key: "7", shiftValue: "&" },
            { code: 56, key: "8", shiftValue: "*" },
            { code: 57, key: "9", shiftValue: "(" },
            { code: 186, key: ";", shiftValue: ":" },
            { code: 189, key: "-" },
            { code: 173, key: "-" },
            { code: 187, key: "=" },
            { code: 8, key: "delete" },
            { code: 219, key: "[", shiftValue: "{" },
            { code: 221, key: "]", shiftValue: "}" },
            { code: 220, key: "\\" },
            { code: 90, key: ";" },
            { code: 222, key: "'", shiftValue: '"' },
            { code: 13, key: "enter" },
            { code: 188, key: "," },
            { code: 190, key: "." },
            { code: 191, key: "/", shiftValue: "?" },
            { code: 16, key: "shift" },
            { code: 9, key: "     " },

            { code: 0o225, key: "á", shiftValue: "Á" },
            { code: 0o233, key: "é", shiftValue: "É" },
            { code: 0o237, key: "í", shiftValue: "Í" },
            { code: 0o243, key: "ó", shiftValue: "Ó" },
            { code: 0o250, key: "ú", shiftValue: "Ú" },
            { code: 0o241, key: "ñ", shiftValue: "Ñ" },
            { code: 0o252, key: "ü", shiftValue: "Ü" },
        ];

        this.isInFocus = true;

        this.mobileKeys = gameData.isMobile;

        this.initKeys();
    }

    initKeys()
    {
        //add touch handle to keys for mobile
        if (this.mobileKeys)
        {
            this.topRow = this.createRow(["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "-", "="]);
            this.secondRow = this.createRow(["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "[", "]", "\\"]);
            this.midRow = this.createRow(["a", "s", "d", "f", "g", "h", "j", "k", "l", ";", "'", "delete"]);
            this.bottomRow = this.createRow(["shift", "z", "x", "c", "v", "b", "n", "m", ":", ",", ".", "/"]);

            const spaceRowKeys = ["space", "enter", "?", "!"];
            if(ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS) {
              spaceRowKeys.push("¿", "¡");
            }
            this.spaceRow = this.createRow(spaceRowKeys);
            this.keys = [this.topRow, this.secondRow, this.midRow, this.bottomRow, this.spaceRow];

            if(ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS) {
              this.keys.unshift(this.spanishRow = this.createRow(["á", "é", "í", "ó", "ú", "ñ", "ü"]));
            }

            this.positionKeys();
        }
        this.isActive = true;
    }

    createRow(keys)
    {
        let row = [];
        while (row.length < keys.length)
        {
            let key = new Key(this.scene, keys[row.length], this.keySizeWidth, this.keySizeHeight);
            key.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handleKeyPress({ currentTarget: key }));
            key.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, () => this.handleKeyUp({ currentTarget: key }));
            row.push(key);
        }

        return row;
    }

    handleKeyPress(e)
    {
        if (this.isActive == true)
        {
            /** @type {Key} */
            let keyPressed = (e.currentTarget.keyValue) ? e.currentTarget : null;
            let keyId;
            let keyVal;
            //exit out of both virtual and real keyboards if key press already triggered
            if (keyPressed && keyPressed.isDown == true) return;

            //show key up state in virtual keyboard
            if (keyPressed)
            {
                if (keyPressed.isDown == false) keyPressed.showKeyPress(true);
                keyId = keyPressed.keyId;
                keyVal = keyPressed.keyValue;

                if (keyPressed.keyValue == "shift")
                {
                    this.shiftOn = !this.shiftOn;
                    if (this.shiftOn)
                    {
                        let key;
                        let i;
                        if(this.spanishRow){
                          for (i = 0; i < this.spanishRow.length; i++)
                          {
                              key = this.spanishRow[i];
                              key.upperCase();
                          }
                        }
                        
                        for (i = 0; i < this.secondRow.length; i++)
                        {
                            key = this.secondRow[i];
                            key.upperCase();
                        }
                        for (i = 0; i < this.midRow.length; i++)
                        {
                            key = this.midRow[i];
                            key.upperCase();
                        }
                        for (i = 0; i < this.bottomRow.length; i++)
                        {
                            key = this.bottomRow[i];
                            key.upperCase();
                        }

                    }
                    else
                    {
                        let key;
                        let i;
                        if(this.spanishRow){
                          for (i = 0; i < this.spanishRow.length; i++)
                          {
                              key = this.spanishRow[i];
                              key.lowerCase();
                          }
                        }
                        
                        for (i = 0; i < this.secondRow.length; i++)
                        {
                            key = this.secondRow[i];
                            key.lowerCase();
                        }
                        for (i = 0; i < this.midRow.length; i++)
                        {
                            key = this.midRow[i];
                            key.lowerCase();
                        }
                        for (i = 0; i < this.bottomRow.length; i++)
                        {
                            key = this.bottomRow[i];
                            key.lowerCase();
                        }
                    }

                    return;
                }
            }

            if (!keyVal) return;
            let event = { _keyId: keyId, _keyValue: keyVal };
            if (event._keyValue == "SPACE" || event._keyValue == "space") event._keyValue = " ";

            this.emit("KEY_PRESS", event);
        }
    }

    handleKeyUp(e)
    {
        let keyPressed = (e.currentTarget.keyValue) ? e.currentTarget : null;
        if (keyPressed)
        {
            if (keyPressed.keyValue != "caps lock") keyPressed.showKeyPress(false);

            if (keyPressed.keyValue != "shift" && this.shiftOn)
            {
                this.shiftOn = false;
                let i;
                let key;
                
                if(this.spanishRow){
                  for (i = 0; i < this.spanishRow.length; i++)
                  {
                      key = this.spanishRow[i];
                      key.lowerCase();
                  }
                }
                
                for (i = 0; i < this.secondRow.length; i++)
                {
                    key = this.secondRow[i];
                    key.lowerCase();
                }
                for (i = 0; i < this.midRow.length; i++)
                {
                    key = this.midRow[i];
                    key.lowerCase();
                }
                for (i = 0; i < this.bottomRow.length; i++)
                {
                    key = this.bottomRow[i];
                    key.lowerCase();
                }
            }
        }
    }

    findKeyByCode(code)
    {
        let i = 0;
        let key = null;
        while (i < this.codes.length && key == null)
        {
            if (this.codes[i]["code"] == code)
            {
                key = this.codes[i];
                break;
            }
            i++;
        }

        return key;
    }

    positionKeys()
    {
        let keyDownColor = gameData.KEY_DOWN_COLOR;
        for (let i = 0; i < this.keys.length; i++)
        {
            let row = this.keys[i];
            let rowWidth = (row.length * (this.keySizeWidth + this.keySpacing)) - this.keySpacing;
            //messy add to width for shift,delete,etc
            if(this.spanishRow){
              if (i == 4 || i == 3) rowWidth += (this.keySizeWidth);
              if (i == 5) rowWidth += (5 * this.keySizeWidth);
            } else {
              if (i == 3 || i == 2) rowWidth += (this.keySizeWidth);
              if (i == 4) rowWidth += (4 * this.keySizeWidth);
            }
            
            let rowStart = -(rowWidth / 2);

            //also messy add to start to make uneven?
            let rowY = (i * (this.keySizeHeight + this.keySpacing)) + 26;
            for (let j = 0; j < row.length; j++)
            {
                let keyUpColor = gameData.KEY_UP_COLOR;
                let key = row[j];
                key.setKeyColors(keyUpColor, keyDownColor);
                key.endX = (j == 0) ? rowStart : row[j - 1].endX + row[j - 1].keyWidth + this.keySpacing;
                key.endY = rowY;
                key.x = key.endX;
                key.y = key.endY;
                this.add(key);
            }
        }
    }
}